/**
 * Centralized STG backend values.
 *
 * stg is centralized here (unlike dev/int/prod, which stay inline per existing
 * convention) because these values are placeholders expected to change: update
 * them in one place and every stg resolver branch picks them up. Hosts follow
 * the confirmed `*.stg.surecolabs.com` scheme; confirm each with the owner
 * before the first real deploy.
 */

// Canonical identifier for the stg environment/stage — single source of truth
// for the literal used in env detection (ENVIRONMENT_STG / isStg) and stage
// checks (STAGE_STG / getStage() === STG).
export const STG = 'stg'

export const STG_ENV = {
  apiUrl: 'https://api.stg.surecolabs.com', // EPS / enrollment-platform
  enrollmeGatewayGraphqlUrl: 'https://enrollmegateway.stg.surecolabs.com/graphql',
  pdfServiceUrl: 'https://pdfservice.stg.surecolabs.com',
  providerServiceUrl: 'https://provider-service.stg.surecolabs.com',
  enrollmentPlatformServiceBaseUrl: 'https://api.stg.surecolabs.com', // confirm
  healthPlanServiceUrl: 'https://stg-api.hixme.com/health-plan', // confirm (EMS-9063) — legacy health-plan (prod: api.hixme.com/health-plan)
  applicationServiceUrl: 'https://stg-api.hixme.com/application', // confirm (EMS-9063) — legacy application service (prod: api.hixme.com/application)
  authServiceUrl: 'https://stg-api.hixme.com/enrollme-auth', // confirm (EMS-9063) — legacy enrollme-auth service (prod: api.hixme.com/enrollme-auth)
  // legacy @hixme/api gateway host (no scheme; @hixme/api adds it) — mirrors admin-web-client
  legacyApiHost: 'ni7la6mqwk.execute-api.us-west-2.amazonaws.com/stg',
  // TODO(EMS-9063): only needed if stg-api.hixme.com doesn't exist
  hixmeApiBase: 'REPLACE_WITH_STG_HIXME_API_BASE_IF_NEEDED',
  launchDarklyClientSideId: '6a3ea44abb6da90ab7dfddb5',
} as const
